import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config.js";
import Pagination from "../Pagination/Paginations.js";
import EntriesSelector from "../Pagination/EntriesSelector";
import DownloadButtons from "../DownloadButtons/DownloadButtons.js";
import "../preloading.css";
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const TrainingReport = () => {

const [topics,setTopics] = useState([]);
const [reports,setReports] = useState([]);
const loadingRef = useRef(false);

const today = new Date().toISOString().split("T")[0];

const [formData,setFormData] = useState({
    start_date:today,
    end_date:today,
    topic_id:"",
    action_type:"fetch"
});

useEffect(()=>{
    fetchTopics();
},[]);

const fetchTopics = async ()=>{
    try{
        const res = await axios.get(API_BASE_URL + "/training-topics", {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });
       
        console.log(res.data);
        setTopics(res.data);
    }catch(err){
        console.error(err);
    }
};

const handleChange = (e)=>{
    setFormData({
        ...formData,
        [e.target.name]:e.target.value
    });
};

const handleSubmit = async (e) => {
  e.preventDefault();
  // block repeat clicks while a request is already running
  if (loadingRef.current) return;
  loadingRef.current = true;

  try {

    // Excel Download
    if (formData.action_type === "list_download") {

      const res = await axios.post(
        `${API_BASE_URL}/training-listreportdownload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`
          },
          responseType: "blob"
        }
      );

      const file = new Blob([res.data], {
        type: "application/vnd.ms-excel"
      });

      const url = window.URL.createObjectURL(file);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "training_report.xls");
      document.body.appendChild(link);
      link.click();
      link.remove();

      return;
    }

    // 🔴 Feedback PDF Download
    if (formData.action_type === "feedback_download") {

      const res = await axios.post(
        `${API_BASE_URL}/training-feedback-download`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`
          },
          responseType: "blob"
        }
      );

      const file = new Blob([res.data], {
        type: "application/pdf"
      });

      const url = window.URL.createObjectURL(file);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "training_feedback.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();

      return;
    }

    // Normal Fetch
    if (formData.action_type === "fetch") {

      const res = await axios.post(
        `${API_BASE_URL}/training-report`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`
          }
        }
      );

      setReports(res.data.data);
    }

  } catch (err) {
    console.error(err);
    toast.error("Something went wrong", { toastId: "training-report-error" });
  } finally {
    loadingRef.current = false;
  }
};

const renderStatus = (value)=>{
    return value === 1
        ? <span style={{color:"green",fontWeight:"bold"}}>Completed</span>
        : <span style={{color:"red",fontWeight:"bold"}}>Not Completed</span>
};




const openFeedbackPdf = async (id) => {
    window.open(API_BASE_URL +'/training-reportdownload/'+id, '_blank')
     };

return (

<div className="container-fluid">

{/* Card 1 */}
<div className="card mb-4">

<h6 className="card-header d-flex align-items-center" style={{ color: "#1d3a8a", fontWeight: 600 }}>
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
    <path fillRule="evenodd" d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.017-1.694a.5.5 0 1 1 .858.257z"/>
    <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>
    <path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z"/>
  </svg>
  Training Report
</h6>

<div className="card-body">

<form onSubmit={handleSubmit}>

<div className="row">

<div className="col-md-2">
<label>From Date</label>
<DatePicker
  selected={formData.start_date ? new Date(formData.start_date) : null}
  onChange={(date) => {
    const value = date ? date.toLocaleDateString("en-CA") : "";
    setFormData((prev) => ({ ...prev, start_date: value }));
  }}
  dateFormat="yyyy-MM-dd"
  placeholderText="Select From Date"
  className="form-control"
  wrapperClassName="w-100"
  maxDate={formData.end_date ? new Date(formData.end_date) : null}
/>
</div>

<div className="col-md-2">
<label>To Date</label>
<DatePicker
  selected={formData.end_date ? new Date(formData.end_date) : null}
  onChange={(date) => {
    const value = date ? date.toLocaleDateString("en-CA") : "";
    setFormData((prev) => ({ ...prev, end_date: value }));
  }}
  dateFormat="yyyy-MM-dd"
  placeholderText="Select To Date"
  className="form-control"
  wrapperClassName="w-100"
  minDate={formData.start_date ? new Date(formData.start_date) : null}
/>
</div>

<div className="col-md-4">
<label>Training Topic</label>
<select
className="form-control"
name="topic_id"
value={formData.topic_id}
onChange={handleChange}
>

<option value="">Select Topic</option>

{topics.map((topic)=>(
<option key={topic.id} value={topic.id}>
{topic.topic_name}
</option>
))}

</select>
</div>

<div className="col-md-2">
<label>Action</label>
<select
className="form-control"
name="action_type"
value={formData.action_type}
onChange={handleChange}
>

<option value="fetch">Fetch</option>
<option value="list_download">List Download</option>
<option value="feedback_download">Feedback Download</option>

</select>
</div>

<div className="col-md-2" style={{marginTop:"30px"}}>
<button className="btn btn-primary btn-sm" style={{ height: "38px" }}>
Get
</button>
</div>

</div>

</form>

</div>

</div>


{/* Card 2 */}

<div className="card">

<div className="table-responsive sticky-table-wrap">

<table className="table table-striped table-bordered sticky-table sticky-head-tint sticky-no-freeze-col">

<thead>

<tr>
<th>Action</th>
<th>Course</th>
<th>Topic</th>
<th>Employee Details</th>
<th>Training Date</th>
<th>Pre-Test Status</th>
<th>Pre-Test Percentage</th>
<th>Training Status</th>
<th>Post Test Status</th>
<th>Post Test Percentage</th>
<th>Feedback Status</th>
</tr>

</thead>

<tbody>

{reports.map((row,index)=>(

<tr key={index}>

<td>
<button
className="btn btn-sm btn-danger"
onClick={() => openFeedbackPdf(row.id)}
>
<i className="fa fa-file-pdf"></i>
</button>
</td>

<td>{row.course_name}</td>
<td>{row.topic_name}</td>
<td>{row.employee_name}</td>
<td>{row.training_date}</td>

<td>{renderStatus(row.pre_test_status)}</td>
<td>{row.pre_test_percentage}%</td>

<td>{renderStatus(row.training_view_status)}</td>

<td>{renderStatus(row.post_test_status)}</td>
<td>{row.post_test_percentage}%</td>

<td>{renderStatus(row.training_feedbacks)}</td>

</tr>

))}

</tbody>

</table>

</div>

</div>

</div>

);
};

export default TrainingReport;